import { IOfferSchema, IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';
import { ISoprProducts,
  getDealTypeSopr,
  getHeadline,
  getCategory,
  getParentId,
  getBrand,
  TVariant,
  TObjectType,
  getVariants,
} from '../tracking';
import { isHomeowner } from '../agent';

export function getProducts(
  agent: IAgentSchema | null,
  offer: IOfferSchema,
  kpId: number | null,
): ISoprProducts {
  return {
    brand: getBrand(agent),
    cianId: offer.cianId,
    dealType: getDealTypeSopr(offer),
    headline: getHeadline(offer),
    hiddenBase: Boolean(offer.isInHiddenBase),
    id: offer.id,
    objectType: getCategory(offer) as TObjectType || 'flat_old,flat_new',
    owner: isHomeowner(offer),
    ownerCianId: agent && agent.cianUserId ? agent.cianUserId : undefined,
    ownerId: agent && agent.realtyUserId ? agent.realtyUserId : undefined,
    parentId: getParentId(offer, kpId),
    photosCount: offer.photos ? offer.photos.length : 0,
    podSnos: Boolean(offer.demolishedInMoscowProgramm),
    position: 1,
    price: offer.bargainTerms.prices.rur,
    published: offer.status === 'published',
    variant: getVariants(offer) as TVariant,
    consultant: offer.isDealRequestSubstitutionPhone,
  };
}
